// extracted by mini-css-extract-plugin
export default {"app_wrapper":"App_app_wrapper__qEX+N","content_wrapper":"App_content_wrapper__r+IYA"};